import dom from '../../../wrapper/DomWrapper';

const resolitionOf = ({ height, width }) => `${width}x${height}`;

export default () => resolitionOf(dom.window.screen);
